var popupStyles = {
    root: function () { return ({}); },
    popup: function (_a) {
        var variables = _a.variables;
        return ({
            zIndex: variables.zIndex,
            position: 'absolute',
        });
    },
};
export default popupStyles;
